import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";
import type { TFunction } from "i18next";
import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";

import { getAuditColumns } from "@/features/Audit/getAuditColumns";

export type A7OPCVMClientPortfolio = {
  id: number;
  date: Date;
  scope: number;
  vehicle: string;
  a7_opcvm_strategy_id: number;
  a7_opcvm_strategy_name: string;
};

const tableName = "a7_opcvm_client_portfolios";

export const getClientPortfoliosColumns = (
  t: TFunction,
): ColumnDef<A7OPCVMClientPortfolio>[] => {
  const tTable = (key: string, defaultValue: string) =>
    t(`${tableName}.columns.${key}`, { ns: "tables", defaultValue });
  const tCommon = (key: string, defaultValue: string) =>
    t(`actions.${key}`, { ns: "common", defaultValue });

  return [
    {
      accessorKey: "id",
      header: tTable("id", "ID"),
    },
    {
      accessorKey: "date",
      header: tTable("date", "Date"),
    },
    {
      accessorKey: "a7_opcvm_strategy_name",
      header: tTable("a7_opcvm_strategy_name", "Fund"),
      cell: ({ row }) => {
        return (
          <Link
            href={toWorkspacePath(
              `/admin/a7-opcvm/a7_opcvm_strategies/${row.original.a7_opcvm_strategy_id}`,
            )}
            className="text-xs"
            underline="hover"
          >
            {row.getValue("a7_opcvm_strategy_name")}
          </Link>
        );
      },
    },
    {
      accessorKey: "scope",
      header: tTable("scope", "Scope"),
    },
    {
      accessorKey: "vehicle",
      header: tTable("vehicle", "Vehicle"),
    },
    {
      id: "actions",
      cell: ({ row }) => {
        return (
          <div className="flex justify-end">
            <Link
              href={`${window.location.pathname}/${row.getValue("id")}`}
              className="text-xs"
              underline="hover"
            >
              {tCommon("edit", "Edit")}
            </Link>
          </div>
        );
      },
    },
  ];
};

export const getClientPortfoliosAuditColumns = (t: TFunction) =>
  getAuditColumns<A7OPCVMClientPortfolio>(getClientPortfoliosColumns(t)).filter(
    (column) =>
      ("accessorKey" in column
        ? String((column as { accessorKey?: unknown }).accessorKey ?? "")
        : "") !== "a7_opcvm_strategy_name",
  );
